import { render, staticRenderFns } from "./AdmittedPremiumTableEngineering.vue?vue&type=template&id=1d640276&scoped=true&"
import script from "./AdmittedPremiumTableEngineering.vue?vue&type=script&lang=js&"
export * from "./AdmittedPremiumTableEngineering.vue?vue&type=script&lang=js&"
import style0 from "./AdmittedPremiumTableEngineering.vue?vue&type=style&index=0&id=1d640276&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d640276",
  null
  
)

export default component.exports